import React from "react";
import "../../../css/Customer/Pages/OurServicesPage/OurGuide.css";
import CardProduct2 from "frontend/Components/DesignSystem/Cards/CardProduct2";

/**
 * OurGuide component displays a guide section with an optional image, title, content, 
 * a list of products, and an optional guide product title.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.imgSrc=""] - The source URL for the main image.
 * @param {string} [props.title=""] - The title of the guide section.
 * @param {React.ReactNode} props.content - The main content or description for the guide.
 * @param {string} [props.guideProductTitle=""] - The title for the products section.
 * @param {Array<Object>} [props.products=[]] - An array of product objects to display.
 * @param {string} [props.imgSrcSmall=""] - The source URL for a smaller image (currently unused).
 * @param {string} [props.altText=""] - The alt text for the main image.
 * @returns {JSX.Element} The rendered OurGuide component.
 */
const OurGuide = ({
  imgSrc = "",
  title = "",
  content,
  guideProductTitle = "",
  products = [],
  imgSrcSmall = "",
  altText = "",
}) => {
  return (
    <div className="Our-Guide-Container">
      <div className="Our-Guide-Content">
        <div>
          {title ? <h2>{title}</h2> : null}
          <div className="Content-Large">{content}</div>
        </div>
        {imgSrc ? (
          <img loading="eager" fetchPriority="high" src={imgSrc} alt={altText} />
        ) : null}
      </div>
      <h3>{guideProductTitle}</h3>
      <div className="Our-Guide-Products">
        {products.map((product, index) => (
          <CardProduct2
            key={index}
            title={product.title}
            content={product.content}
            onClick={() => {}}
          />
        ))}
      </div>
    </div>
  );
};

export default OurGuide;
